// Canonicalize a search term to the stored MAC format so a server-side
// substring match works regardless of how the user typed it.
//
// MACs are stored uppercase with colons (e.g. "98:8C:81:D5:1D:74"). A user
// may type "988c81d51d74", "98-8c-81-...", or "98:8c:81". We only transform
// terms that *look* like a (partial) MAC — hex digits plus the usual
// separators (:, -, space). Anything containing other letters (a device or
// user name) is returned unchanged so normal text search still works.
//
// Examples:
//   "988c81d51d74"  -> "98:8C:81:D5:1D:74"
//   "98:8c:81"      -> "98:8C:81"      (partial — matches as a prefix)
//   "98 8c 81"      -> "98:8C:81"
//   "Light"         -> "Light"         (left untouched)
export function formatMacForSearch(input: string): string {
    const raw = (input || '').trim()
    if (!raw) return raw
    // hex + separators only? if not, it's not a MAC — leave it alone
    if (!/^[0-9a-fA-F:\-\s]+$/.test(raw)) return raw
    const hex = raw.replace(/[:\-\s]/g, '').toUpperCase()
    if (!hex) return raw
    return hex.match(/.{1,2}/g)!.join(':')
}
